import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticlesPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/news`)
      .then((r) => setNews(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="articles-page" className="pt-20">
      {/* Header */}
      <div className="bg-[#F5F5F5] py-16 lg:py-24 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#699ab6] font-medium mb-3">
            Actualités
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl font-medium text-[#333333] tracking-tight mb-4">
            Nos articles
          </h1>
          <p className="text-[#777777] text-base font-light max-w-xl">
            Retrouvez nos derniers articles informatifs sur l'immobilier,
            le droit et le marché genevois.
          </p>
        </div>
      </div>

      {/* Articles Grid */}
      <div className="py-12 lg:py-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3].map((i) => (
                <div key={i} className="animate-pulse">
                  <div className="aspect-[16/10] bg-[#F0F0F0] mb-4" />
                  <div className="h-5 bg-[#F0F0F0] w-3/4 mb-2" />
                  <div className="h-3 bg-[#F0F0F0] w-1/2 mb-3" />
                  <div className="h-3 bg-[#F0F0F0] w-full" />
                </div>
              ))}
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-20">
              <p className="font-heading text-2xl text-[#333333] mb-3">
                Aucun article pour le moment
              </p>
              <p className="text-[#777777] text-sm font-light">
                Revenez bientôt pour découvrir nos actualités
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
              {news.map((article) => (
                <Link
                  key={article.id}
                  to={`/actualites/${article.id}`}
                  data-testid={`article-item-${article.id}`}
                  className="group block"
                >
                  <div className="overflow-hidden aspect-[16/10] mb-5 bg-[#F5F5F5]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <p className="text-[10px] text-[#999] uppercase tracking-wider mb-2">
                    {new Date(article.created_at).toLocaleDateString("fr-CH", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                  <h2 className="font-heading text-xl font-medium text-[#333333] mb-2 group-hover:text-[#699ab6] transition-colors">
                    {article.title}
                  </h2>
                  <p className="font-accent italic text-[#699ab6] text-sm mb-3">
                    {article.subtitle}
                  </p>
                  <p className="text-sm text-[#777] font-light leading-relaxed line-clamp-3">
                    {article.content}
                  </p>
                  <span className="inline-block mt-3 text-[11px] uppercase tracking-[0.15em] font-medium text-[#699ab6] group-hover:underline">
                    Lire la suite
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
